import {
    ResizableHandle, ResizablePanel, ResizablePanelGroup
} from 'shared/components/ui/resizable';
import FolderSection from './FolderSection';
import DocumentSection from './DocumentSection';

/**
 * This component would contain elements inside the Document View section _e.g. Document Table_
 * @component
 * @returns {React.JSX}
 */
export default function DocumentView() {

    return (
        <>
            <div className="m-6 mt-4">
                <div className="border border-neutral-200 rounded-xl overflow-hidden h-full">
                    <ResizablePanelGroup direction="horizontal">
                        <ResizablePanel className="flex flex-col" minSize={15} defaultSize={25}>
                            <FolderSection />
                        </ResizablePanel>
                        {/* ================================================= */}
                        <ResizableHandle className="bg-neutral-200" />
                        {/* ================================================= */}
                        <ResizablePanel className="flex flex-col">
                            <DocumentSection />
                        </ResizablePanel>
                    </ResizablePanelGroup>
                </div>
            </div>
        </>
    );
}